import { combineReducers } from 'redux';
import ACTIONS from './actions';

const feedData = (state = { feedCard: {} }, action) => {
    switch (action.type) {
        case ACTIONS.FEED_ATHLETE_AVATAR:
            const avatarUrl = action.avatarUrl;
            return {
                ...state,
                avatarUrl
            };
        case ACTIONS.FEED_SUMMARY_LOAD:
            const summaryFeedProgram = action.summaryFeedProgram;
            const session = action.session;
            return {
                ...state,
                summaryFeedProgram,
                session
            };
        case ACTIONS.FEED_ATHLETE:
            const userResponse = action.userResponse;
            return {
                ...state,
                userResponse
            };
        case ACTIONS.FEED_IMAGE_UPLOADED:
            const imageUploaded = action.imageUploaded;
            return {
                ...state,
                imageUploaded
            };
        case ACTIONS.FEED_CARD_LOAD:
            const feedCard = action.card;
            return {
                ...state,
                feedCard
            };
        case ACTIONS.FEED_CARD_ADD_REPLY:
            return {
                ...state,
                feedCard: {
                    ...action.feedCard,
                    replies: [...action.feedCard.replies, action.reply]
                }
            };
        case ACTIONS.FEED_REFRESH:
            const refreshInput = action.refreshInput;
            return {
                ...state,
                refreshInput
            };
        case ACTIONS.FEED_REPLY:
            const nReply = action.nReply;
            return {
                ...state,
                nReply
            };
        case ACTIONS.FEED_ACTION:
            const actionFeed = action.actionFeed;
            return {
                ...state,
                actionFeed
            };
        case ACTIONS.DELETE_COMMENT_FEED:
            const fReply = action.fReply;
            const fParentFeed = action.fParentFeed;
            return {
                ...state,
                fReply,
                fParentFeed
            };
        default:
            return state;
    }
};

export default combineReducers({
    feedData
});
